
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Nav } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import { redireactlink } from 'shared/assets/icons';
import { MenuCategoryInput } from '../form/FormInput';
import { resetBreadcrumbs } from '../breadcrumbs/Breadcrumbs';

import './NavigationBar.scss';
import { addDataLayer } from 'shared/utils/utils';

export const NavigationBarHOC = ({ props, menus, menuStyling={}, onClickCallback }) => {

    const [navMenus, setNavMenus] = useState(menus);

    const dispatch = useDispatch();

    useEffect(() => {
        // Checking show or hide menus
        let navigationMenus = [];
        menus.forEach(menu => {
            if ( menu.showOrHide ) {
                if ( menu.showOrHide(props.user) ) {
                    navigationMenus.push(menu);
                }
            } else {
                navigationMenus.push(menu);
            }
        });

        // Setting active menus
        navigationMenus.forEach(element => { element.active = false; });
        const idx = navigationMenus.findIndex(elem => elem.redirectTo === props.location.pathname);
        if ( idx > -1 ) {
            navigationMenus[idx].active = true;
        }

        setNavMenus(navigationMenus);
    }, [props.user, props.location.pathname]);

    const onMenuOpen = (index) => {
        navMenus[index].active = true;
        setNavMenus([...navMenus]);
    };

    const onMenuClose = (index) => {
        setNavMenus((prevState)=>{
            prevState[index].active = false;
            return ([...prevState])
        })
    };

    const onClickLink = (menu) => {
        let dataLayerData = {
            'event': menu.dataLayer
        }
        addDataLayer(dataLayerData);

        resetBreadcrumbs();
        dispatch({
            type: 'PUSH_TO_STATE', payload: {}
        });
    };

    const onClickMenuItem = (item) => {
        if ( item.redirectTo ) {
            props.history.push(item.redirectTo);
        } else if ( item.openUrl ) {
            window.open(item.openUrl, "_blank");
            if(item.label == "Sell with Us") {
                let dataLayerData = {
                    'event': 'sell_with_us'
                }
                addDataLayer(dataLayerData); 
            }
        }
    };

    return (
        <Nav className="nav-bar">
            {
                navMenus.map((menu, index) => 
                    <Nav.Item className={menu.active ? 'active' : ''} key={"navigation-bar-" + menu.id}>
                        {
                            menu.type === 'category-menu' ?
                            <MenuCategoryInput icon={
                                <div role='button' className='dropdown-menu-link'>
                                    <div>{menu.label}</div>
                                    {menu.icon}
                                </div>
                            } items={menu.items} onMenuOpen={() => {
                                        dispatch({
                                            type: 'PUSH_TO_STATE', payload: {}
                                        })  
                             onMenuOpen(index); }} onMenuClose={() => { 
                                onMenuClose(index); 
                            }} 
                            history={props?.history}
                            /> : null
                        }
                        {
                            menu.type === 'link' ? 
                            <Link to={menu.redirectTo} className={`nav-link ${menu.icon ? 'd-flex gap-1' : ''}`} style={menuStyling} onClick={ () => { onClickLink(menu)} }>
                                <span>{menu.icon}</span>
                                <span>{menu.label}</span>
                            </Link> : null
                        }
                        {menu.type === 'modal' ?
                            <div role='button' className='dropdown-menu-link' style={menuStyling} onClick={() => { menu?.action() }}>
                                <div>{menu.label}</div>
                                {menu.icon}
                            </div> : null
                        }
                        {menu.type === 'external-link' ?
                            <div role='button' className='dropdown-menu-link' style={menuStyling} onClick={() => { onClickMenuItem(menu); }}>
                                <div>{menu.label } 
                               {menu.icon && <span style={{marginLeft: '5px'}}>
                                {redireactlink}
                                </span>}
                                </div>
                                {menu.icon}
                            </div>: null
                        }
                    </Nav.Item>
                )
            }
        </Nav>
    )
};